import WebDevelopment from "../../assets/ServiceStack/web_dev.png";
import WebDesign from "../../assets/ServiceStack/web_design.png";
import MobileDev from "../../assets/ServiceStack/mobile_dev.png";
import ECommerce from "../../assets/ServiceStack/e_commerce.png";
import Reputation from "../../assets/ServiceStack/repitation_management.png";
import DigitalMarketing from "../../assets/ServiceStack/digital_marketing.png";
import GraphicDesigning from "../../assets/ServiceStack/graphic_designing.png";
import Brand from "../../assets/ServiceStack/brand.png";
import Social1 from "../../assets/ServiceStack/social-1.png";
import Social2 from "../../assets/ServiceStack/social-2.png";
import Social3 from "../../assets/ServiceStack/social-3.png";
import Seo from "../../assets/ServiceStack/seo.png";
import { motion } from "framer-motion";

const serviceStack = [
  {
    id: 1,
    serviceList: [
      {
        id: 1,
        serviceName: "WEB DEVELOPMENT",
        icon: WebDevelopment,
      },
      {
        id: 2,
        serviceName: "WEB DESIGN",
        icon: WebDesign,
      },
      {
        id: 3,
        serviceName: "MOBILE APP DEVELOPMENT",
        icon: MobileDev,
      },
      {
        id: 4,
        serviceName: "ECOMMERCE SOLUTIONS",
        icon: ECommerce,
      },
      // {
      //   id: 5,
      //   serviceName: "REPUTATION MANAGEMENT",
      //   icon: Reputation,
      // },
      // {
      //   id: 6,
      //   serviceName: "DIGITAL MARKETING",
      //   icon: DigitalMarketing,
      // },
      {
        id: 7,
        serviceName: "GRAPHIC DESIGNING",
        icon: GraphicDesigning,
      },
      {
        id: 8,
        serviceName: "SEO",
        icon: Seo,
      },
    ],
  },
  {
    id: 2,
    serviceList: [
      // {
      //   id: 1,
      //   serviceName: "SEO",
      //   icon: Seo,
      // },
      // {
      //   id: 2,
      //   serviceName: "SOCIAL MEDIA OPTIMIZATION",
      //   icon: Social1,
      // },
      // {
      //   id: 3,
      //   serviceName: "SOCIAL MEDIA MARKETING",
      //   icon: Social3,
      // },
      // {
      //   id: 4,
      //   serviceName: "BRAND PROMOTION",
      //   icon: Brand,
      // },
      // {
      //   id: 5,
      //   serviceName: "GRAPHIC DESIGNING",
      //   icon: GraphicDesigning,
      // },
      // {
      //   id: 6,
      //   serviceName: "ADWORDS/PPC",
      //   icon: Social2,
      // },
    ],
  },
];

const containerVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.5, ease: "easeOut" },
  }),
};

export default function ServiceStack() {
  return (
    <div className="w-full flex flex-col gap-10 my-16 px-4 sm:px-8 md:px-16 lg:px-28">
      {/* Header */}
      <div className="text-center mb-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl lg:text-5xl font-semibold text-primary-color/90"
        >
          Ideal IT Solutions for Your Enterprise
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-base text-gray-600 mt-3 max-w-2xl mx-auto"
        >
          High-impact services tailored to help your business grow, scale and
          succeed.
        </motion.p>
      </div>

      {/* Services Grid */}
      <div className="flex flex-col gap-16">
        {serviceStack.map((category, idx) => (
          <motion.div
            key={category.id}
            custom={idx}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={containerVariants}
            className="flex flex-col gap-10"
          >
            <div
              className="
                w-full grid 
                grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 
                gap-6 md:gap-8
              "
            >
              {category.serviceList.map((service) => (
                <motion.div
                  key={service.id}
                  whileHover={{ scale: 1.06, y: -4 }}
                  whileTap={{ scale: 0.97 }}
                  transition={{ type: "spring", stiffness: 200 }}
                  className="flex flex-col items-center gap-4 cursor-pointer"
                >
                  {/* Icon Container */}
                  <div
                    className="
                    bg-white shadow-sm border border-gray-100
                    h-24 w-24 md:h-32 md:w-32 lg:h-36 lg:w-36 
                    flex justify-center items-center rounded-3xl 
                    hover:shadow-md transition-all duration-200
                    p-4
                  "
                  >
                    <img
                      src={service.icon}
                      alt={service.serviceName}
                      className="h-10 md:h-20 lg:h-28 object-contain select-none"
                      draggable={false}
                    />
                  </div>

                  {/* Name */}
                  <p className="font-semibold text-xs md:text-sm lg:text-base text-gray-700 text-center leading-tight select-none">
                    {service.serviceName}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
